import { render, staticRenderFns } from "./FeedbackView.vue?vue&type=template&id=277db66e&scoped=true&"
import script from "./FeedbackView.vue?vue&type=script&lang=ts&"
export * from "./FeedbackView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277db66e",
  null
  
)

export default component.exports